<template>
  <v-snackbar
    :color="color"
    v-model="shown"
    :timeout="timeout"
    :id="'snackbar--' + id"
  >
    {{ text }}
    <template v-slot:action="{ attr }">
      <v-btn icon @click="closeMessage()" v-bind="attr">
        <v-icon>mdi-close-circle</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "StatusMessage",
  computed: {
    ...mapState("snackbar", ["color", "timeout", "text", "id"]),

    shown: {
      get() {
        return this.$store.state.snackbar.shown;
      },
      set(val) {
        this.$store.commit("snackbar/toggleMessage", val);
      }
    }
  },
  methods: {
    closeMessage() {
      this.$store.commit("snackbar/toggleMessage", false);
    }
  }
};
</script>

<style></style>
